import React from 'react';
import GenericModal, { IGenericModalProps } from './../GenericModal/GenericModal';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { ModalsActionsClose } from './../../store/modules/ModalsActionTypes';
import { IModalProps } from './../../store/modules/ModalsReducer';
import { connect, useDispatch } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { Grid } from '@material-ui/core';
import { useStyles } from './styles'

export interface IAlertModalGenericProps extends IGenericModalProps {
  contentText: string,
  title: string,
  key: string
}

export interface IAlertModal extends IModalProps {
  genericProps: IAlertModalGenericProps,
  modalsActionsClose: (key: string) => ModalsActionsClose
}

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({
  modalsActionsClose
}, dispatch);

const AssembleiaDocsModal = ({ genericProps }: IAlertModal) => {

  const classes = useStyles();
  const dispatchAction = useDispatch();

  const toClose = (): void => {
    if (genericProps && genericProps.key) {
      dispatchAction(modalsActionsClose(genericProps.key));
    }
  }

  return (
    <GenericModal
      title={ (<span dangerouslySetInnerHTML={{ __html: genericProps.title }} />) }
      content={(
        <Grid container className={ classes.root }>
          <Grid item xs={12} sm={12} md={12} lg={12} className={ classes.content }>
            <span dangerouslySetInnerHTML={{ __html: genericProps.contentText }} />
          </Grid>
        </Grid>
      )}
      genericProps={{
        maxWidth: 'sm',
        onClose: toClose,
      }}
    />
  )
}

export default connect(null, mapDispatchToProps)(AssembleiaDocsModal);
